import DeviceList from 'components/DeviceList';
import { RevisionRow } from 'components/tables/data/revision/types';

/**
 * Column for the devices.
 * In view-by-device mode, only the _singleDevice for this row is shown.
 */
export default function DevicesColumn({ data: { devices, _singleDevice } }: { data: RevisionRow }) {
  if (_singleDevice) {
    return <DeviceList devices={[_singleDevice]} limit={1} />;
  }

  return <DeviceList devices={devices} limit={1} />;
}
